/**
 * Product Info Accordions Script
 * Håndterer toggle funktionalitet for accordions i product information sektionen
 */

(function() {
  'use strict';
  
  // Initialisering når DOM er loaded
  document.addEventListener('DOMContentLoaded', initAccordions);
  
  /**
   * Initialiserer alle accordion toggles i sektionen
   */
  function initAccordions() {
    // Find alle accordion toggles med data-accordion-toggle attribute
    const toggleButtons = document.querySelectorAll('[data-accordion-toggle]');
    
    toggleButtons.forEach(button => {
      button.addEventListener('click', toggleAccordion);
    });
  }
  
  /**
   * Toggle accordion åben/lukket
   * @param {Event} event - Click event
   */
  function toggleAccordion(event) {
    const button = event.currentTarget;
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    const contentId = button.getAttribute('aria-controls');
    const contentElement = document.getElementById(contentId);
    
    // Toggle aria-expanded attribute
    button.setAttribute('aria-expanded', !isExpanded);
    
    // Toggle content visibility
    if (contentElement) {
      contentElement.classList.toggle('hidden');
    }
    
    // Toggle icons (plus/minus)
    const plusIcon = button.querySelector('.plus-icon');
    const minusIcon = button.querySelector('.minus-icon');
    
    if (plusIcon && minusIcon) {
      plusIcon.classList.toggle('hidden');
      minusIcon.classList.toggle('hidden');
    }
  }
})();